/// <reference types="./types/css-modules" />

// Type declaration for single-spa globals
declare global {
  interface Window {
    __POWERED_BY_QIANKUN__?: boolean;
    singleSpaNavigate?: (...args: unknown[]) => void;
  }
}

// Async imports to handle Module Federation shared dependencies
const loadReact = () => import('react');
const loadReactDOM = () => import('react-dom/client');
const loadReactRouter = () => import('react-router-dom');
const loadApp = () => import('./app/app');

// Module Federation mount function for Angular shell
export async function mountMfe(element: HTMLElement) {
  const [{ default: React }, { createRoot }, { BrowserRouter }, { default: App }] = await Promise.all([
    loadReact(),
    loadReactDOM(),
    loadReactRouter(),
    loadApp(),
  ]);

  const root = createRoot(element);
  root.render(
    React.createElement(BrowserRouter, { basename: '/counsel' }, React.createElement(App))
  );

  return () => {
    root.unmount();
  };
}

// Standalone mount function for development
async function mountStandalone(element: HTMLElement) {
  const [{ default: React }, { createRoot }, { BrowserRouter }, { default: App }] = await Promise.all([
    loadReact(),
    loadReactDOM(),
    loadReactRouter(),
    loadApp(),
  ]);

  const root = createRoot(element);
  // No basename for standalone development
  root.render(
    React.createElement(BrowserRouter, {}, React.createElement(App))
  );

  return () => {
    root.unmount();
  };
}

const lifecycles = {
  bootstrap: async () => {
    console.log('Counsellor Web MFE bootstrapping');
  },
  mount: async (props: { domElement?: HTMLElement }) => {
    const element = props?.domElement || document.getElementById('root');
    if (element) {
      return mountMfe(element);
    }
  },
  unmount: async () => {
    console.log('Counsellor Web MFE unmounting');
  }
};

export const { bootstrap, mount: singleSpaMount, unmount } = lifecycles;

// Export for Module Federation (Angular shell)
export const mount = mountMfe;
export default mountMfe;

// Standalone development mode - check if not running in single-spa context
if (!window.__POWERED_BY_QIANKUN__ && !window.singleSpaNavigate) {
  const container = document.getElementById('root');
  if (container) {
    mountStandalone(container).then((unmount) => {
      // Store unmount function for potential cleanup
      (window as unknown as { __COUNSELLOR_WEB_UNMOUNT__: () => void }).__COUNSELLOR_WEB_UNMOUNT__ = unmount;
    }).catch(err => console.error('Failed to mount Counsellor Web MFE:', err));
  }
}
